import {
  ItemsResponse,
  SecurityQuestion,
  parseErrorContainer,
  type JsonHelper,
} from "../../../tastyworks"
import type HttpClient from "../../../tastyworks/http"
import {
  RECOVERY_CODES_STATUS_DESER,
  RecoveryCodesStatus,
} from "../../../tastyworks/recovery-codes"
import {
  updateSingleResponse,
  type SingleResponse,
} from "../../../tastyworks/response"
import { SECURITY_QUESTION_DESER } from "../../../tastyworks/user"

export class AdminCredentialService {
  private readonly usersClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.usersClient = baseHttpClient.nested("users")
  }

  readonly fetchSecurityQuestions = async (
    userId: string
  ): Promise<ItemsResponse<SecurityQuestion>> =>
    this.usersClient
      .get(`${userId}/security-questions`)
      .then((res) => this.parseSecurityQuestions(res))

  readonly fetchRecoveryCodesStatus = async (
    userId: string
  ): Promise<SingleResponse<RecoveryCodesStatus>> =>
    this.usersClient
      .get(`${userId}/recovery-code-status`)
      .then((res) =>
        updateSingleResponse(
          res,
          new RecoveryCodesStatus(),
          RECOVERY_CODES_STATUS_DESER.update
        )
      )

  private readonly parseSecurityQuestions = (
    helper: JsonHelper
  ): ItemsResponse<SecurityQuestion> => {
    const response = new ItemsResponse<SecurityQuestion>()

    parseErrorContainer(helper, response)

    if (!helper.hasField("data")) {
      return response
    }
    const data = helper.getChild("data")
    response.items = data.parseArray(
      "items",
      SECURITY_QUESTION_DESER.toParser(SecurityQuestion)
    )

    return response
  }
}
